import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  checkin: string | null;
  checkout: string | null;
  status: ReduxStateType;
}

const initialState: InitialState = {
  checkin: null,
  checkout: null,
  status: ReduxStateType.ERROR,
};

const getTimeCheckInOnlineSlice = createSlice({
  name: "getTimeCheckInOnline",
  initialState,
  reducers: {
    getTimeCheckInOnlineStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getTimeCheckInOnlineSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.checkin = action.payload.checkIn;
      state.checkout = action.payload.checkOut;
    },
    getTimeCheckInOnlineFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getTimeCheckInOnlineStart,
  getTimeCheckInOnlineSuccess,
  getTimeCheckInOnlineFailed,
} = getTimeCheckInOnlineSlice.actions;

export default getTimeCheckInOnlineSlice.reducer;
